import React, { useState, useEffect } from 'react';
import { DONATION_AMOUNTS } from '../constants';

const DonationPanel = () => {
  const amounts = DONATION_AMOUNTS;

  const handleDonation = (link) => {
    // Open donation link in new tab
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="donation-panel">
      <p>Support EnBooken's Development</p>
      <div className="donation-amounts">
        {amounts.map(({ amount, link }) => (
          <button
            key={amount}
            className="donation-button"
            onClick={() => handleDonation(link)}
          >
            ${amount}
          </button>
        ))}
      </div>
      <p className="donation-note">Your support helps keep EnBooken free and ad-free!</p>
    </div>
  );
};

const ProcessingPanel = ({ isProcessing, isPackaging, zipResult, onDownload, onClose }) => {
  const [fairUseConfirmed, setFairUseConfirmed] = useState(false);

  useEffect(() => {
    if (!isProcessing && !isPackaging && !zipResult) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isProcessing, isPackaging, zipResult, onClose]);

  if (!isProcessing && !isPackaging && !zipResult) return null;

  return (
    <div className="processing-panel-overlay">
      <div className="processing-panel">
        <button className="close-button" onClick={onClose}>&times;</button>
        {isProcessing || isPackaging ? (
          <div className="processing-content">
            <div className="spinner" />
            <p>{isPackaging ? 'Packaging your files...' : 'Processing your PDF...'}</p>
          </div>
        ) : (
          <div className="download-content">
            <h3>Your booklet is ready!</h3>

            <DonationPanel />

            <div className="fair-use-section">
              <label className="fair-use-label">
                <input
                  type="checkbox"
                  checked={fairUseConfirmed}
                  onChange={(e) => setFairUseConfirmed(e.target.checked)}
                />
                I confirm that this PDF will be used in accordance with fair use principles
                and applicable copyright laws.
              </label>
            </div>

            <p className="filename">{zipResult?.filename}</p>
            <button
              className="download-button"
              onClick={onDownload}
              disabled={!fairUseConfirmed}
            >
              Download Booklet
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessingPanel;
